const fr = {
  // Navigation
  "nav.home": "Accueil",
  "nav.about": "À propos",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Feuille de route",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Mises à jour",
  "nav.fwb": "FWB",
  "nav.tokensale": "Vente de Tokens",
  
  // Common sections
  "common.learnMore": "En savoir plus",
  "common.buyNow": "Acheter maintenant",
  "common.contactUs": "Contactez-nous",
  "common.loading": "Chargement",
  
  // Home page
  "home.hero.title": "L'évolution des paiements numériques",
  "home.hero.subtitle": "eDOP Token : Le token utilitaire pour l'écosystème financier de la République Dominicaine",
  "home.hero.cta": "Participer à la prévente",
  "home.title": "eDOP: Révolution Numérique",
  
  // About
  "about.title": "À propos du Token eDOP",
  "about.description": "eDOP Token est un token numérique conçu pour révolutionner les paiements en République Dominicaine",
  
  // Page À propos
  "about.page.title": "À Propos de Nous",
  
  // Bulles de la page À propos
  "bubbles.about.edop.title": "À Propos d'eDOP",
  "bubbles.about.edop.content": "eDOP est une alternative numérique efficace et accessible dans l'écosystème crypto, conçue pour résoudre les problèmes d'accès financier, en particulier dans les marchés émergents. Elle intègre la facilité d'utilisation avec la sécurité, visant une adoption mondiale.",
  
  "bubbles.about.mission.title": "Notre Mission",
  "bubbles.about.mission.content": "Démocratiser l'accès aux services financiers numériques, en offrant des outils accessibles qui permettent aux personnes de prendre le contrôle de leurs finances sans intermédiaires coûteux.",
  
  "bubbles.about.transparency.title": "Transparence",
  "bubbles.about.transparency.content": "Toutes les opérations sont enregistrées de manière immuable sur la blockchain, garantissant une transparence absolue. De plus, nous nous engageons à publier les résultats des audits de sécurité pour créer la confiance.",
  
  "bubbles.about.innovation.title": "Innovation",
  "bubbles.about.innovation.content": "Nous innovons en offrant une solution crypto centrée sur l'utilisateur pour l'inclusion financière, avec un écosystème qui comprend des paiements à faible coût, des incitations, et des développements futurs tels qu'un DEX propriétaire et une application mobile.",
  
  "bubbles.about.community.title": "Communauté",
  "bubbles.about.community.content": "Nous encourageons une communauté engagée grâce à un système d'incitations qui récompense la participation, le staking et l'utilisation active de l'écosystème, visant une distribution équilibrée et l'expansion de notre base d'utilisateurs.",
  
  "bubbles.about.team.title": "Notre Équipe",
  "bubbles.about.team.content": "Nous avons une équipe multidisciplinaire avec une vaste expérience en finance numérique, développement blockchain et marchés émergents, soutenue par des conseillers stratégiques dans des domaines clés tels que la réglementation et l'économie.",
  
  "bubbles.about.technology.title": "Notre Technologie",
  "bubbles.about.technology.content": "eDOP est un token BEP-20 qui fonctionne sur la BNB Smart Chain (BSC), choisie pour son équilibre optimal entre vitesse, sécurité et coûts abordables, utilisant des contrats intelligents développés selon les meilleures pratiques.",
  
  "bubbles.about.speed.title": "Vitesse",
  "bubbles.about.speed.content": "Grâce à la BNB Smart Chain, les transactions avec eDOP Token sont confirmées rapidement, généralement entre 3 et 15 secondes, offrant une efficacité supérieure aux systèmes traditionnels et autres blockchains.",
  
  "bubbles.about.lowcost.title": "Faible Coût",
  "bubbles.about.lowcost.content": "eDOP offre des frais drastiquement réduits, se situant entre 0% et 1% par transaction, comparé à 5% à 10% pour les services de transfert d'argent traditionnels. Ceci est réalisé grâce à l'utilisation du réseau efficace BNB Smart Chain, des contrats intelligents optimisés et l'élimination des intermédiaires, permettant des transactions abordables, même pour les micropaiements.",
  
  "bubbles.about.security.title": "Sécurité et Contact",
  "bubbles.about.security.content": "La sécurité est une priorité, mettant en œuvre des contrats audités par des entreprises reconnues, des outils éprouvés (OpenZeppelin), des systèmes multi-signatures et une surveillance constante. Pour toute question, contactez-nous à info@edoptoken.com, admin@edoptoken.com, ou via nos réseaux sociaux officiels publiés sur notre site web.",
  
  // Tokenomics
  "tokenomics.title": "Distribution des Tokens",
  "tokenomics.supply": "Offre totale",
  
  // Page Tokenomics
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "Distribution et Économie du Token eDOP",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Contenu: Le token eDOP a une offre totale fixe de 1 milliard d'unités (1 000 000 000 eDOP). Sa conception économique comprend une distribution stratégique pour encourager la participation précoce, récompenser les utilisateurs à long terme par le staking, assurer la liquidité du marché et financer le développement continu et l'adoption de l'écosystème.",
  
  "tokenomics.distribution.title": "Distribution du Token",
  "tokenomics.distribution.content": "L'offre totale de 1 milliard d'eDOP est allouée comme suit:",
  "tokenomics.distribution.items": [
    "40% Prévente publique: Pour les premiers adoptants.",
    "30% Récompenses de Staking: Distribuées sur 2 ans pour récompenser les détenteurs.",
    "10% Liquidité: Bloquée pour un minimum de 10 ans ou à perpétuité pour la stabilité.",
    "10% Marketing et adoption: Pour la croissance et la sensibilisation.",
    "5% Développement: Avec libération progressive pour l'équipe (vesting).",
    "5% Inventaire de chaîne: Pour les opérations techniques de l'écosystème."
  ],
  
  "tokenomics.purpose.title": "eDOP: Un Token avec un Objectif",
  "tokenomics.purpose.content": "Avec une offre totale limitée à 1 milliard d'unités, le token eDOP est conçu pour être utile et durable. Sa distribution stratégique assure des fonds pour les récompenses de staking (30%), la liquidité à long terme (10%) et la croissance. Principalement, vous pouvez utiliser eDOP comme un moyen de paiement efficace et à faible coût, ou le bloquer (staking) pour obtenir des récompenses et des avantages supplémentaires dans notre écosystème financier numérique.",
  
  "tokenomics.utility.title": "Utilité du Token",
  "tokenomics.utility.items": [
    "Gouvernance: Les détenteurs d'eDOP peuvent voter sur des propositions clés qui affectent le développement et l'orientation du projet.",
    "Staking: Obtenez des récompenses significatives en stakant vos tokens, avec des taux annuels compétitifs.",
    "Frais Réduits: Les utilisateurs qui possèdent eDOP bénéficient de frais réduits sur toutes les transactions au sein de la plateforme.",
    "Accès aux Fonctionnalités Exclusives: Débloquez des fonctionnalités avancées et des outils dans notre plateforme.",
    "Moyen de Paiement: Utilisez eDOP pour des transactions rapides et économiques au sein de notre écosystème."
  ],
  
  // Token sale
  "tokensale.title": "Vente de Tokens",
  "tokensale.subtitle": "Participez à notre prévente",
  "tokensale.price": "Prix actuel",
  "tokensale.connect": "Connecter portefeuille",
  
  // Footer
  "footer.rights": "Tous droits réservés",
  "footer.terms": "Termes et conditions",
  "footer.privacy": "Politique de confidentialité",
  "footer.fwb": "Amis avec Avantages",
  
  // Wallet
  "wallet.connect": "Connecter Portefeuille",
  
  // News
  "news.label": "ACTUALITÉS",
  
  // Bulles de la page d'accueil
  "bubbles.home.revolution.title": "eDOP: Révolution du Marché",
  "bubbles.home.revolution.content": "Le token eDOP vise à fournir une alternative numérique efficace et accessible dans l'écosystème des cryptomonnaies, avec un focus initial sur les marchés émergents et une vision d'adoption mondiale.",
  
  "bubbles.home.ecosystem.title": "L'Écosystème eDOP",
  "bubbles.home.ecosystem.content": "Ne manquez pas l'opportunité de faire partie de la prochaine génération de solutions blockchain dans le monde crypto.",
  
  // Boutons et textes supplémentaires
  "cta.whitepaper": "Livre Blanc",
  
  // Page Politique de Confidentialité
  "privacy.page.title": "Politique de Confidentialité",
  
  // Bulles de la Politique de Confidentialité
  "bubbles.privacy.commitment.title": "Engagement envers Votre Confidentialité",
  "bubbles.privacy.commitment.content": "Chez eDOP Token, nous nous engageons à une transparence totale et à la protection de vos données. En tant que projet axé sur la démocratisation de l'accès aux services financiers numériques, nous comprenons l'importance de la confiance.",
  
  "bubbles.privacy.nocollection.title": "Nous Ne Collectons Pas d'Informations",
  "bubbles.privacy.nocollection.content": "Pour remplir notre mission d'inclusion financière, nous ne demandons jamais de données d'identification. Évitez d'être victime de phishing et ne révélez jamais vos clés privées ou phrases de récupération - eDOP Token ne vous les demandera jamais, souvenez-vous en.",
  
  "bubbles.privacy.usage.title": "Comment Nous Utilisons Vos Informations",
  "bubbles.privacy.usage.content": "Nous ne collectons pas de données personnelles ni aucune information. Nous utilisons uniquement votre adresse de portefeuille pour opérer, des données techniques pour maintenir la sécurité de la plateforme et, optionnellement, quelques détails qui améliorent votre expérience. Tout cela sous de bonnes pratiques et sans partager d'informations avec des tiers.",
  
  "bubbles.privacy.security.title": "Sécurité et Protection",
  "bubbles.privacy.security.content": "Nous appliquons les mêmes mesures de sécurité qui protègent nos contrats intelligents: protocoles OpenZeppelin, multi-signatures dans les opérations clés, limites pour réduire les risques et surveillance constante. Tout est aligné avec nos audits, garantissant la sécurité de vos données et actifs numériques.",
  
  // Page Amis avec Avantages (FWB)
  "fwb.page.title": "Amis avec Avantages (FWB)",
  
  // Bulles de la page FWB
  "bubbles.fwb.community.title": "Communauté eDOP (FWB)",
  "bubbles.fwb.community.content": "Chez eDOP, nous croyons en une communauté mondiale qui cherche à démocratiser l'accès financier. Notre écosystème est conçu pour que les utilisateurs prennent le contrôle et collaborent vers une économie numérique plus équitable, en particulier dans les marchés émergents.",
  
  "bubbles.fwb.join.title": "Comment Rejoindre et Participer",
  "bubbles.fwb.join.content": "Devenez un membre actif d'eDOP en utilisant le token pour les paiements, en participant à notre programme de staking pour soutenir le réseau, et en vous préparant à contribuer à la future gouvernance de l'écosystème. Votre participation est essentielle à notre croissance.",
  "bubbles.fwb.join.date": "Date: 04 avril 2025",
  
  "bubbles.fwb.benefits.title": "Avantages de la Communauté eDOP",
  "bubbles.fwb.benefits.content": "En participant à eDOP, vous pouvez gagner des récompenses périodiques grâce au staking (provenant de 30% de l'offre totale allouée). De plus, la détention active peut vous donner accès à des avantages tels que des réductions sur les frais ou la priorité sur les nouvelles fonctionnalités de l'écosystème.",
  
  "bubbles.fwb.connect.title": "Connectez-vous avec la Communauté",
  "bubbles.fwb.connect.content": "Restez informé et connecté avec le projet eDOP. Trouvez des liens vers nos canaux communautaires officiels, la documentation technique et les méthodes de contact directement sur notre site web officiel.",
  
  // Page Termes et Conditions
  "terms.page.title": "Termes et Conditions",
  
  // Bulles de la page Termes
  "bubbles.terms.risk.title": "Avertissements de Risque :",
  "bubbles.terms.risk.content": "L'investissement dans eDOP Token implique des risques importants, notamment une forte volatilité et la perte totale ou partielle possible du capital. La valeur du token dépend du marché, il n'y a aucune garantie de rentabilité, et les actifs numériques ne bénéficient pas d'une assurance-dépôts. Considérez attentivement votre tolérance au risque avant d'investir.",
  
  "bubbles.terms.liability.title": "Limitation de Responsabilité",
  "bubbles.terms.liability.content": "La performance d'eDOP Token est soumise à des risques de marché indépendants de la volonté de l'émetteur (Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL). Nous ne sommes pas responsables des pertes résultant de la volatilité, des fluctuations de liquidité ou des risques inhérents à l'investissement dans des actifs numériques.",
  
  "bubbles.terms.issuer.title": "Émetteur et Conformité Légale",
  "bubbles.terms.issuer.content": "eDOP Token est émis par Servicios de Desarrollo de Algoritmos y Consultoría de Tecnología Blockchain, SRL, une entité légalement constituée. Nous cherchons à opérer conformément aux réglementations applicables et disposons de conseils juridiques en matière d'actifs numériques et de droit financier.",
  
  "bubbles.terms.contact.title": "Contact",
  "bubbles.terms.contact.content": "Pour toute question concernant ces termes, le projet eDOP Token ou pour plus d'informations, vous pouvez contacter notre Email : ou consulter des ressources supplémentaires sur notre Site Web.",
  
  // Page Mises à jour de développement
  "devupdates.page.title": "Mises à jour de développement",
  
  // Bulles de la page Mises à jour
  "bubbles.devupdates.intro.title": "Mises à jour de développement",
  "bubbles.devupdates.intro.content": "Selon le plan technique décrit dans le livre blanc, le développement d'eDOP se concentre sur la création de composants clés tels qu'une plateforme de paiement à faible coût, un futur échange décentralisé propriétaire (DEX) et une application mobile. L'ensemble de l'écosystème est conçu pour fonctionner sur la BNB Smart Chain, recherchant un équilibre entre efficacité, sécurité et accessibilité.",
  
  "bubbles.devupdates.latest.title": "Dernières mises à jour",
  "bubbles.devupdates.latest.content": "Basés sur le plan original du livre blanc et en préparation de notre Phase 1 (estimée pour la fin du Q2 2025), notre focus actuel comprend les préparatifs du lancement du token, l'activation de la plateforme de paiement et la sécurisation des inscriptions initiales sur les échanges. Pour les progrès réels et les annonces confirmées, veuillez toujours consulter nos canaux officiels.",
  "bubbles.devupdates.latest.date": "Date: 28 avril 2025",
  
  "bubbles.devupdates.events.title": "Prochains événements communautaires",
  "bubbles.devupdates.events.content": "Notre communauté établira un plan d'interaction active avec la communauté, mentionnant des stratégies telles que des webinaires éducatifs réguliers et une présence lors d'événements clés du secteur. Bien que les dates pour les prochaines sessions AMA ou autres événements spécifiques ne soient pas précisées dans le document, notre engagement est de maintenir une communication fluide et éducative.",
  "bubbles.devupdates.events.date": "Date: 28 avril 2025",
  
  "bubbles.devupdates.technical.title": "Mise à jour technique: Audit des Smart Contracts",
  "bubbles.devupdates.technical.content": "Conformément à notre approche de sécurité décrite dans le livre blanc, il existe un engagement pour que les contrats intelligents d'eDOP Token soient audités par des entreprises externes reconnues (des exemples tels que CertiK ou Hacken sont mentionnés) avant le lancement. La publication de ces rapports d'audit sur notre site web est prévue pour une transparence totale avec la communauté.",
  "bubbles.devupdates.technical.date": "Date: 28 avril 2025",
  
  "bubbles.devupdates.partnership.title": "Annonce de partenariat stratégique",
  "bubbles.devupdates.partnership.content": "Notre livre blanc établit la stratégie et l'importance de former des alliances stratégiques pour la croissance et l'utilité d'eDOP Token, mentionnant des plans pour collaborer avec des commerçants, en particulier sur les marchés émergents. Cependant, le document fondateur ne contient pas d'annonces spécifiques de partenariats déjà signés; il décrit l'intention et l'approche pour les rechercher dans le cadre de la feuille de route.",
  "bubbles.devupdates.partnership.date": "Date: 28 avril 2025",
  
  "bubbles.devupdates.previous.title": "Mises à jour précédentes",
  "bubbles.devupdates.previous.content1": "Le livre blanc sert de plan directeur initial et de présentation du projet eDOP Token. Par sa nature, les mises à jour précédentes ou les jalons déjà atteints depuis sa publication apparaîtront dans les canaux officiels d'information.",
  "bubbles.devupdates.previous.content2": "Pour accéder à une archive des nouvelles, avancées et annonces précédentes, veuillez vous diriger vers les sections actualités/blog ou les canaux historiques sur les réseaux sociaux officiels d'eDOP. Revenez ici pour voir toutes nos mises à jour précédentes!",

  // Roadmap Page
  "roadmap.page.title": "Feuille de Route",
  "roadmap.page.subtitle": "Notre vision et objectifs pour l'avenir",

  // Roadmap Phases
  "roadmap.phase1.title": "Phase 1 : Fondamentaux et Lancement",
  "roadmap.phase1.description": "Développement des fondamentaux du token et lancement de la prévente",
  "roadmap.phase1.items": [
    "Développement et audit du Smart Contract",
    "Prévente du Token",
    "Construction de la communauté",
    "Lancement du site web"
  ],

  "roadmap.phase2.title": "Phase 2 : Lancement sur le Marché et Expansion",
  "roadmap.phase2.description": "Listing sur DEX et début des campagnes marketing",
  "roadmap.phase2.items": [
    "Listing sur DEX",
    "Campagnes marketing",
    "Partenariats stratégiques",
    "Croissance de la communauté"
  ],

  "roadmap.phase3.title": "Phase 3 : Développement des Produits",
  "roadmap.phase3.description": "Développement de la plateforme de paiement et intégration du portefeuille",
  "roadmap.phase3.items": [
    "Bêta de la plateforme de paiement",
    "Intégration du portefeuille",
    "Intégration des commerçants",
    "Audits de sécurité"
  ],

  "roadmap.phase4.title": "Phase 4 : Expansion de l'Écosystème",
  "roadmap.phase4.description": "Élargissement de l'écosystème et nouvelles fonctionnalités",
  "roadmap.phase4.items": [
    "Lancement de l'App mobile",
    "Intégration Cross-Chain",
    "Implémentation de la Gouvernance",
    "Nouveaux partenariats"
  ],

  // Roadmap Status
  "roadmap.status.completed": "Terminé",
  "roadmap.status.inProgress": "En Cours",
  "roadmap.status.upcoming": "À Venir",

  // Roadmap Additional Sections
  "roadmap.vision.title": "Notre Vision",
  "roadmap.vision.content": "Façonner l'avenir des paiements numériques en République Dominicaine et au-delà",

  "roadmap.updates.title": "Mises à Jour Récentes",
  "roadmap.updates.content": "Restez informé de nos progrès",

  // Page de Vesting
  "vesting.page.title": "Plateforme de Vesting eDOP",

  // Page de Vesting - Bulles
  "bubbles.vesting.platform.title": "Plateforme de Vesting eDOP",
  "bubbles.vesting.platform.content": "Les tokens destinés à l'équipe de développement (5% du total) ne sont pas livrés en une seule fois. D'abord, ils sont complètement bloqués pendant 120 jours. Ensuite, l'équipe reçoit une petite portion chaque mois (2% linéaire de leur allocation). Ce processus s'appelle vesting et garantit que l'équipe reste engagée dans le projet eDOP Token sur le long terme.",
  
  "bubbles.vesting.emission.title": "Émission Graduelle de Tokens",
  "bubbles.vesting.emission.content": "eDOP contrôle la sortie lente de tokens avec le vesting pour l'équipe et la distribution graduelle des récompenses de staking (30% sur 2 ans). Cette émission contrôlée vise à éviter les chutes brutales de prix et à aligner la circulation des tokens avec la croissance du projet.",

  // Page de Staking
  "staking.page.title": "Plateforme de Staking eDOP",
  
  // Bulles de Staking
  "bubbles.staking.platform.title": "Plateforme de Staking eDOP",
  "bubbles.staking.platform.content": "C'est la fonction au sein d'eDOP où vous pouvez bloquer vos tokens pour soutenir le projet. En échange de leur blocage, la plateforme vous offre des récompenses (plus de tokens eDOP).",
  
  "bubbles.staking.benefits.title": "Avantages du Staking",
  "bubbles.staking.benefits.items": [
    "Gagnez plus d'eDOP : Vous recevez des tokens supplémentaires en récompense pour avoir bloqué les vôtres.",
    "Participez aux décisions : Cela vous donne l'opportunité de voter ou d'influencer l'avenir du projet.",
    "Soutenez le token : Vous aidez à rendre la valeur du token plus stable à long terme."
  ],
  
  "bubbles.staking.rewards.title": "Récompenses",
  "bubbles.staking.rewards.content": "Vous pourrez réclamer vos récompenses accumulées une fois que la fonction de réclamation sera active sur la plateforme.",
  
  // Composant StakingBox4
  "stakingBox4.totalRewards": "RÉCOMPENSES TOTALES",
  "stakingBox4.claimRewards": "Réclamer les Récompenses",
  "stakingBox4.processing": "Traitement en cours...",
  "stakingBox4.claimed": "Réclamé",
  "stakingBox4.success": "Succès !",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Accepter",
  "stakingBox4.noRewards": "Pas de récompenses disponibles à réclamer",
  "stakingBox4.claimedSuccess": "Récompenses réclamées avec succès ! Vous avez reçu {{amount}} $eDOP",
  "stakingBox4.errorClaiming": "Impossible de réclamer les récompenses",
  "stakingBox4.userRejected": "La transaction a été rejetée par l'utilisateur",
  "stakingBox4.insufficientFunds": "Fonds insuffisants pour effectuer la transaction",
  "stakingBox4.contractRejection": "La transaction a été rejetée par le contrat",
  
  // Composant StakingBox3
  "stakingBox3.estimatedRewards": "RÉCOMPENSES ESTIMÉES",
  "stakingBox3.rewardsDynamic": "• Le pourcentage de récompenses est dynamique",
  "stakingBox3.monthly": "• Mensuel = {{rate}}%",
  "stakingBox3.daily": "• Quotidien = {{rate}}%",
  
  // Composant StakingBox2
  "stakingBox2.poolPercentage": "% DU POOL",
  "stakingBox2.stakedBalance": "SOLDE STAKÉ",
  "stakingBox2.processing": "Traitement en cours...",
  "stakingBox2.withdrawTokens": "Retirer les Tokens",
  "stakingBox2.success": "Succès !",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Accepter",
  "stakingBox2.tokensWithdrawn": "Tokens retirés avec succès",
  "stakingBox2.errorWithdrawing": "Impossible de retirer les tokens",
  "stakingBox2.userRejected": "La transaction a été rejetée par l'utilisateur",
  "stakingBox2.insufficientFunds": "Fonds insuffisants pour effectuer la transaction",
  "stakingBox2.contractRejection": "La transaction a été rejetée par le contrat",
  "stakingBox2.infoModal.title": "Pourcentage du Pool",
  "stakingBox2.infoModal.content": "Ce pourcentage représente la proportion de vos tokens stakés par rapport au total des tokens en staking. Plus votre pourcentage est élevé, plus la proportion de récompenses que vous recevrez sera importante.",
  "stakingBox2.infoModal.understood": "Compris",

  // Composant StakingBox1
  "stakingBox1.stakedBalance": "SOLDE STAKÉ",
  "stakingBox1.stakeable": "VOTRE STAKEABLE",
  "stakingBox1.stakeNow": "STAKER MAINTENANT",
  "stakingBox1.success": "Succès !",
  "stakingBox1.info": "INFO",
  "stakingBox1.accept": "Accepter",
  "stakingBox1.connectWallet": "Veuillez connecter votre portefeuille d'abord",
  "stakingBox1.enterValidAmount": "Veuillez entrer un montant valide",
  "stakingBox1.errorStaking": "Un problème est survenu lors du staking de vos tokens",
  "stakingBox1.userRejected": "La transaction a été rejetée par l'utilisateur",
  "stakingBox1.insufficientFunds": "Fonds insuffisants pour effectuer la transaction",
  "stakingBox1.contractRejection": "La transaction a été rejetée par le contrat",
  "stakingBox1.stakeTokens": "Staker les Tokens",
  "stakingBox1.processingTransaction": "Traitement de la Transaction",
  "stakingBox1.waitForStaking": "Veuillez patienter pendant que votre staking est terminé...",
  "stakingBox1.transactionSuccess": "Transaction Réussie !",
  "stakingBox1.successStaked": "Vous avez staké avec succès {{amount}} $eDOP",
  "stakingBox1.exit": "Sortir",
  "stakingBox1.available": "Disponible : {{amount}}",
  "stakingBox1.confirm": "Accepter",
  "stakingBox1.cancel": "Annuler",
  
  // Composant StakingSupply
  "stakingSupply.title": "Approvisionnement Total en Staking",
  "stakingSupply.totalSupply": "Approvisionnement Total (Millions)",
  
  // Mois abrégés pour les graphiques
  "months.jan": "Jan",
  "months.feb": "Fév",
  "months.mar": "Mar",
  "months.apr": "Avr",
  "months.may": "Mai",
  "months.jun": "Juin",
  "months.jul": "Juil",
  "months.aug": "Août",
  "months.sep": "Sep",
  "months.oct": "Oct",
  "months.nov": "Nov",
  "months.dec": "Déc",
  
  // Composant PresaleBox
  "presaleBox.buyMessage": "ACHETEZ $eDOP MAINTENANT",
  "presaleBox.days": "Jours",
  "presaleBox.hours": "Heures",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Sec",
  "presaleBox.presalePending": "Prévente à venir",
  "presaleBox.presaleCompleted": "Prévente terminée",
  "presaleBox.stage": "Étape {{current}} sur {{total}}",
  "presaleBox.fundsRaised": "USDT collectés : ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "Vos Tokens eDOP Achetés : {{amount}}",
  "presaleBox.tokensStaked": "Vos tokens $eDOP stakés = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Payer avec {{currency}}",
  "presaleBox.receive": "Recevoir $eDOP",
  "presaleBox.maximum": "Maximum",
  "presaleBox.insufficientFunds": "Vous n'avez pas assez de {{currency}} pour payer cette transaction.",
  "presaleBox.buyWithBnb": "Acheter avec {{symbol}}",
  "presaleBox.buyWithUsdt": "Acheter avec {{symbol}}",
  "presaleBox.buyWithCard": "Acheter avec Carte",
  "presaleBox.goToDex": "Aller au DEX",
  "presaleBox.balance": "Solde en {{currency}} :",
  "presaleBox.connectWallet": "Connectez votre portefeuille",
  "presaleBox.reloadBnb": "Pas assez de BNB ? Rechargez ici",
  "presaleBox.developedBy": "Développé par",
  
  // Modal d'information pour PresaleBox
  "presaleBox.infoModal.title": "Attention !",
  "presaleBox.infoModal.tokensPurchased": "Le total des tokens que vous avez achetés correspond à tous les tokens acquis avec le portefeuille connecté. Cela inclut tous les tokens stakés et non stakés.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "Les $eDOP non réclamés achetés avec ETH ou USDT ERC-20 peuvent être utilisés en staking maintenant. Veuillez noter que tous les tokens utilisés dans le staking anticipé peuvent être retirés 7 jours après l'activation de la réclamation des tokens, qui se produira après la conclusion de la prévente.",
  
  // Alertes pour PresaleBox
  "presaleBox.alert.connectWallet": "Veuillez d'abord connecter votre portefeuille",
  "presaleBox.alert.enterValidAmount": "Veuillez entrer un montant valide",
  "presaleBox.alert.presaleNotStarted": "La prévente commence le 01 juin 2025. Veuillez attendre le début de la prévente.",
  "presaleBox.alert.confirmInWallet": "Veuillez confirmer la transaction dans votre portefeuille...",
  "presaleBox.alert.purchaseSuccess": "Achat réussi ! Vous avez acheté {{amount}} tokens eDOP",
  "presaleBox.alert.paymentMethodNotSupported": "Méthode de paiement non prise en charge",
  
  // Erreurs simplifiées pour PresaleBox
  "presaleBox.error.insufficientTokens": "Il n'y a pas assez de tokens disponibles pour le moment. Veuillez réessayer plus tard.",
  "presaleBox.error.userDenied": "Transaction rejetée. Vous devez confirmer la transaction dans votre portefeuille pour continuer.",
  "presaleBox.error.gas": "Erreur de gas pour la transaction. Assurez-vous d'avoir suffisamment de BNB pour couvrir les frais de gas.",
  "presaleBox.error.nonce": "Erreur de séquence de transaction. Essayez de rafraîchir la page et réessayez.",
  "presaleBox.error.contractFailure": "La transaction a échoué. Le contrat pourrait être en pause ou à court de tokens.",
  "presaleBox.error.generic": "Erreur de transaction. Veuillez réessayer plus tard.",
  
  // Réseau requis pour PresaleBox
  "presaleBox.network.bnbMainnet": "BNB Smart Chain",
  "presaleBox.network.bnbTestnet": "BSC Testnet",
  "presaleBox.network.bnbBoth": "BNB Smart Chain ou BSC Testnet",
  "presaleBox.network.usdtBep20": "BNB Smart Chain (pour USDT BEP-20)",
  "presaleBox.network.usdtErc20": "Ethereum (pour USDT ERC-20)",
  "presaleBox.network.usdtTestnet": "BSC Testnet (pour USDT Testnet)",
  "presaleBox.network.usdtOptions": "Ethereum (pour USDT ERC-20) ou BNB Smart Chain (pour USDT BEP-20)",
  "presaleBox.network.usdtOptionsTestnet": "Ethereum (pour USDT ERC-20) ou BNB Smart Chain/Testnet (pour USDT BEP-20)",
  "presaleBox.network.compatible": "réseau compatible",
  "presaleBox.network.changeNetwork": "Pour payer avec {{method}}, vous devez passer au réseau {{network}}",
  
  // Messages d'erreur pour les contrats
  "contracts.error.invalidConfig": "Contrat {{contractName}} non configuré correctement",
  "contracts.error.initialization": "Erreur d'initialisation du contrat {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "Le contrat n'est pas initialisé",
  "contracts.error.walletNotConnected": "Portefeuille non connecté. Veuillez connecter votre portefeuille pour continuer",
  "contracts.error.transaction": "Erreur de transaction: {{error}}",
  "errors.contractInitialization": "Erreur lors de l'initialisation des contrats",
  
  // Erreurs de portefeuille
  "wallet.error.noMetamask": "MetaMask n'est pas installé",
  "wallet.error.noAccount": "Impossible d'obtenir le compte",
  "wallet.error.networkNotSupported": "Réseau non pris en charge",
  "wallet.error.connection": "Erreur lors de la connexion du portefeuille",
  "wallet.error.networkSwitch": "Erreur lors du changement de réseau",
  
  // Messages d'erreur pour la prévente
  "presale.error.connectWalletFirst": "Veuillez d'abord connecter votre portefeuille",
  "presale.error.contractNotReady": "Le contrat de prévente n'est pas prêt",
  "presale.error.noSigner": "Impossible d'obtenir le signataire. Veuillez reconnecter votre portefeuille.",
  "presale.error.priceChanged": "Erreur de prix : Le prix a changé. Veuillez rafraîchir la page.",
  "presale.error.userRejected": "Transaction rejetée par l'utilisateur",
  "presale.error.insufficientFunds": "Fonds insuffisants pour compléter la transaction",
  "presale.error.purchaseError": "Erreur d'achat : {{error}}",
  "presale.error.unknown": "Inconnu",
  "presale.error.usdtApprovalError": "Erreur d'approbation USDT",
  "presale.error.cannotClaimTokens": "Impossible de réclamer des tokens pour le moment",
  
  // Messages de console - pour les développeurs uniquement, non affichés aux utilisateurs
  "console.contracts.initialized": "Contrats de prévente initialisés avec succès",
  "console.contracts.initError": "Erreur lors de l'initialisation des contrats:",
  "console.tokens.availableError": "Erreur lors du chargement des tokens disponibles:",
  "console.exchangeRates.error": "Erreur lors de la récupération des taux de change:",
  "console.price.error": "Erreur lors de l'obtention du prix du contrat:",
  "console.price.fromContract": "Prix obtenu du contrat:",
  "console.price.contractError": "Erreur lors de l'obtention du prix du contrat:",
  "console.price.usingFallback": "Utilisation du prix de secours:",
  "console.bnb.buying": "Achat avec BNB: {{amount}} BNB pour obtenir {{tokensToReceive}} tokens",
  "console.price.perToken": "Prix par token: {{price}} USDT",
  "console.signer.available": "Signataire disponible: {{available}}",
  "console.account.current": "Compte actuel: {{account}}",
  "console.bnb.success": "Achat BNB réussi:",
  "console.bnb.error": "Erreur lors de l'achat avec BNB:",
  "console.usdt.approving": "Approbation des dépenses USDT...",
  "console.price.fromContractUsdt": "Prix obtenu du contrat (USDT):",
  "console.price.contractErrorUsdt": "Erreur lors de l'obtention du prix du contrat (USDT):",
  "console.price.usingFallbackUsdt": "Utilisation du prix de secours (USDT):",
  "console.usdt.buying": "Achat avec USDT: {{amount}} USDT avec prix {{price}} par token",
  "console.tokens.expected": "Tokens attendus: {{tokens}}",
  "console.usdt.success": "Achat USDT réussi:",
  "console.usdt.error": "Erreur lors de l'achat avec USDT:",
  "console.tokens.claimSuccess": "Tokens réclamés avec succès:",
  "console.tokens.claimError": "Erreur lors de la réclamation des tokens:",
  "console.purchases.error": "Erreur lors de la récupération des données d'achat:",

  // Messages du Ticker
  "ticker.message1": "1️⃣ Rejoignez la prévente eDOP ! 🚀 Profitez des prix exclusifs avant le lancement. 🔥",
  "ticker.message2": "2️⃣ eDOP révolutionne le marché ! 💎 Rejoignez l'écosystème et assurez votre place dans la nouvelle ère numérique. ⚡",
  "ticker.message3": "3️⃣ Derniers jours de la prévente eDOP ! ⏳ Ne restez pas en dehors, obtenez vos tokens avant qu'il ne soit trop tard. 🎯",

  // Balises Meta
  "meta.description": "eDOP Token - La monnaie de l'écosystème financier dominicain"
};

export default fr;